import { rest } from 'msw';
import {
  baseUrl,
  bopisEndpoint,
  bopisLeadTimeEndpoint,
  rfidApprovalsEndpoint,
  rfidCountEndpoint,
  rfidEndpoint,
  rfidOverviewEndpoint,
  rfidSalesRetaggingEndpoint,
  stockAccuracyEndpoint,
  stockInventoryCountEndpoint,
  StorePerformanceInterval,
} from '../../constants';
import {
  getFetchRfidApprovalsDataMockResponse,
  getFetchRfidSalesRetaggingDataMockResponse,
  getMockBopisData,
  getMockBopisLeadTimeResponse,
  getMockRfidCountData,
  getMockStockInventoryCountData,
  getRfidStockAccuracyData,
} from '../mocks';

export const fetchRfidCountData = (addDelay = false) =>
  rest.get(`${baseUrl}${rfidEndpoint}/:storeId${rfidCountEndpoint}`, (_, res, ctx) => {
    const mockData = getMockRfidCountData();

    return res(
      ctx.status(200),
      ctx.json(mockData),
      ctx.set('Content-Type', 'application/json'),
      ctx.delay(addDelay ? 500 : 0),
    );
  });

export const mockRfidApprovalsData = (addDelay = false) => {
  return rest.get(`${baseUrl}${rfidEndpoint}/:storeId${rfidApprovalsEndpoint}`, (_req, res, ctx) => {
    const interval = _req.url.searchParams.get('interval');

    const mockData = getFetchRfidApprovalsDataMockResponse(interval || 'Daily');

    return res(
      ctx.status(200),
      ctx.json(mockData),
      ctx.set('Content-Type', 'application/json'),
      ctx.delay(addDelay ? 500 : 0),
    );
  });
};

export const mockRfidSalesRetaggingData = (addDelay = false) =>
  rest.get(`${baseUrl}${rfidEndpoint}/:storeId${rfidSalesRetaggingEndpoint}`, (_, res, ctx) => {
    const mockData = getFetchRfidSalesRetaggingDataMockResponse();

    return res(
      ctx.status(200),
      ctx.json(mockData),
      ctx.set('Content-Type', 'application/json'),
      ctx.delay(addDelay ? 500 : 0),
    );
  });

export const mockStockInventoryCount = (addDelay = false) =>
  rest.get(`${baseUrl}${rfidEndpoint}/:storeId${stockInventoryCountEndpoint}`, (_, res, ctx) => {
    const mockData = getMockStockInventoryCountData();

    return res(
      ctx.status(200),
      ctx.json(mockData),
      ctx.set('Content-Type', 'application/json'),
      ctx.delay(addDelay ? 500 : 0),
    );
  });

export const mockFetchStockAccuracyData = (addDelay = false) =>
  rest.get(`${baseUrl}${rfidEndpoint}/:storeId${stockAccuracyEndpoint}`, (req, res, ctx) => {
    const mockData = getRfidStockAccuracyData(req, res, ctx);
    return res(
      ctx.status(200),
      ctx.json(mockData),
      ctx.set('Content-Type', 'application/json'),
      ctx.delay(addDelay ? 500 : 0),
    );
  });

export const fetchBopisData = (addDelay?: boolean) =>
  rest.get(`${baseUrl}${rfidEndpoint}/:storeId${bopisEndpoint}`, (_req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json(getMockBopisData()),
      ctx.set('Content-Type', 'application/json'),
      ctx.delay(addDelay ? 500 : 0),
    );
  });

export const mockFetchBopisLeadTimeData = (addDelay?: boolean) =>
  rest.get(`${baseUrl}${rfidEndpoint}/:storeId${bopisLeadTimeEndpoint}`, (_req, res, ctx) => {
    const interval = _req.url.searchParams.get('interval') as StorePerformanceInterval | null;
    const fromDate = _req.url.searchParams.get('fromDate');

    return res(
      ctx.status(200),
      ctx.json(
        getMockBopisLeadTimeResponse(
          interval || StorePerformanceInterval.DAILY,
          fromDate ? new Date(fromDate) : new Date(),
        ),
      ),
      ctx.set('Content-Type', 'application/json'),
      ctx.delay(addDelay ? 500 : 0),
    );
  });

// Area Overview Widget Mock Data
export const mockFetchRfidOverviewData = (addDelay = false) =>
  rest.get(`${baseUrl}${rfidEndpoint}/:storeId${rfidOverviewEndpoint}`, (req, res, ctx) => {
    const mockData = getRfidStockAccuracyData(req, res, ctx);
    return res(
      ctx.status(200),
      ctx.json(mockData),
      ctx.set('Content-Type', 'application/json'),
      ctx.delay(addDelay ? 500 : 0),
    );
  });
